import { useReveal } from "@/hooks/useReveal";

export default function OneOrder() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section className="bg-ink py-20 md:py-24">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal text-center max-w-[800px] mx-auto">
          <h2 className="text-cream font-serif text-3xl md:text-4xl font-semibold">
            One supplier, one consolidated order
          </h2>
          <p className="mt-5 text-cream/80 text-lg leading-relaxed">
            Sachets, bulk sugar for the kitchen, cocoa powder for the bar, and
            if it is useful, specialty coffee, herbal infusions and spices —
            all packed in the same facility and consolidated into the same
            container. For a group buying across several sites, that is one
            supplier relationship and one set of documents instead of four.
          </p>
        </div>
      </div>
    </section>
  );
}